import { Box } from '@zillow/constellation-10';
import { TermType } from '@zg-rentals/ts-id-verification-client';
import { CicTac, CicTacNew, ExperianPp, ExperianTac, NoticeToUsers } from '../../../constants/terms';

function getHtml({ termType, currentVersion }: { termType: TermType; currentVersion?: number }): string {
  switch (termType) {
    case TermType.EXPERIAN_TAC:
      return ExperianTac;
    case TermType.EXPERIAN_PRIVACY_POLICY:
      return ExperianPp;
    case TermType.EXPERIAN_CIC_WRITTEN_CONSENT_RENTER:
      return NoticeToUsers;
    case TermType.CIC_TAC:
      return currentVersion === 3 ? CicTacNew : CicTac;
    default:
      return '<div />';
  }
}
export default function TermsHtml({ termType, currentVersion }: { termType: TermType; currentVersion?: number }) {
  const html = getHtml({ termType, currentVersion });
  return (
    <Box
      dangerouslySetInnerHTML={{
        __html: html,
      }}
    />
  );
}
